import { render, staticRenderFns } from "./InvoiceStockModfierGenisView.vue?vue&type=template&id=6a4abbc3&scoped=true&"
import script from "./InvoiceStockModfierGenisView.vue?vue&type=script&lang=ts&"
export * from "./InvoiceStockModfierGenisView.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceStockModfierGenisView.vue?vue&type=style&index=0&id=6a4abbc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4abbc3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
